import { gql } from '@apollo/client'

const CREATE_ORDER_DELIVERY = gql`
  mutation createOrderDelivery(
    $deliveryDate: Date!
    $deliveryTimeStart: Time!
    $deliveryTimeEnd: Time!
    $startingSiteBdnId: UUID
    $deliverySiteBdnId: UUID
    $unloadingSiteBdnId: UUID
    $startingSiteId: UUID
    $deliverySiteId: UUID
    $unloadingSiteId: UUID
    $startingSiteAddress: String
    $startingSiteCity: String
    $deliverySiteAddress: String
    $deliverySiteCity: String
    $unloadingSiteAddress: String
    $unloadingSiteCity: String
    $status: String!
    $commentPublic: String
    $commentPrivate: String
    $commentDriver: String
    $commandId: UUID!
    $userId: UUID
    $licensePlate: String
    $isPlanificationSent: Boolean
  ) {
    createOrderDelivery(
      input: {
        orderDelivery: {
          deliveryDate: $deliveryDate
          deliveryTimeStart: $deliveryTimeStart
          deliveryTimeEnd: $deliveryTimeEnd
          startingSiteBdnId: $startingSiteBdnId
          deliverySiteBdnId: $deliverySiteBdnId
          unloadingSiteBdnId: $unloadingSiteBdnId
          startingSiteId: $startingSiteId
          deliverySiteId: $deliverySiteId
          unloadingSiteId: $unloadingSiteId
          startingSiteAddress: $startingSiteAddress
          startingSiteCity: $startingSiteCity
          deliverySiteAddress: $deliverySiteAddress
          deliverySiteCity: $deliverySiteCity
          unloadingSiteAddress: $unloadingSiteAddress
          unloadingSiteCity: $unloadingSiteCity
          status: $status
          commentPublic: $commentPublic
          commentPrivate: $commentPrivate
          commentDriver: $commentDriver
          commandId: $commandId
          userId: $userId
          licensePlate: $licensePlate
          isPlanificationSent: $isPlanificationSent
        }
      }
    ) {
      orderDelivery {
        id
      }
    }
  }
`

const UPDATE_ORDER_DELIVERY = gql`
  mutation updateOrderDelivery(
    $id: UUID!
    $deliveryDate: Date!
    $deliveryTimeStart: Time!
    $deliveryTimeEnd: Time!
    $startingSiteBdnId: UUID
    $deliverySiteBdnId: UUID
    $unloadingSiteBdnId: UUID
    $startingSiteId: UUID
    $deliverySiteId: UUID
    $unloadingSiteId: UUID
    $startingSiteAddress: String
    $startingSiteCity: String
    $deliverySiteAddress: String
    $deliverySiteCity: String
    $unloadingSiteAddress: String
    $unloadingSiteCity: String
    $status: String!
    $commentPublic: String
    $commentPrivate: String
    $commentDriver: String
    $userId: UUID
    $licensePlate: String
    $isPlanificationSent: Boolean
  ) {
    updateOrderDelivery(
      input: {
        patch: {
          deliveryDate: $deliveryDate
          deliveryTimeStart: $deliveryTimeStart
          deliveryTimeEnd: $deliveryTimeEnd
          startingSiteBdnId: $startingSiteBdnId
          deliverySiteBdnId: $deliverySiteBdnId
          unloadingSiteBdnId: $unloadingSiteBdnId
          startingSiteId: $startingSiteId
          deliverySiteId: $deliverySiteId
          unloadingSiteId: $unloadingSiteId
          startingSiteAddress: $startingSiteAddress
          startingSiteCity: $startingSiteCity
          deliverySiteAddress: $deliverySiteAddress
          deliverySiteCity: $deliverySiteCity
          unloadingSiteAddress: $unloadingSiteAddress
          unloadingSiteCity: $unloadingSiteCity
          status: $status
          commentPublic: $commentPublic
          commentPrivate: $commentPrivate
          commentDriver: $commentDriver
          userId: $userId
          licensePlate: $licensePlate
          isPlanificationSent: $isPlanificationSent
        }
        id: $id
      }
    ) {
      clientMutationId
    }
  }
`

const CREATE_ORDER_DELIVERY_MATERIAL = gql`
  mutation createOrderDeliveryMaterial(
    $commandMaterialId: UUID!
    $orderDeliveryId: UUID!
    $materialId: UUID!
    $quantity: BigFloat!
  ) {
    createOrderDeliveryMaterial(
      input: {
        orderDeliveryMaterial: {
          commandMaterialId: $commandMaterialId
          orderDeliveryId: $orderDeliveryId
          materialId: $materialId
          quantity: $quantity
        }
      }
    ) {
      clientMutationId
    }
  }
`

const UPDATE_ORDER_DELIVERY_MATERIAL = gql`
  mutation updateOrderDeliveryMaterial($id: UUID!, $materialId: UUID!, $quantity: BigFloat!) {
    updateOrderDeliveryMaterial(
      input: { patch: { materialId: $materialId, quantity: $quantity }, id: $id }
    ) {
      clientMutationId
    }
  }
`

const DELETE_ORDER_DELIVERY_MATERIAL = gql`
  mutation deleteOrderDeliveryMaterial($id: UUID!) {
    deleteOrderDeliveryMaterial(input: { id: $id }) {
      clientMutationId
    }
  }
`

const ORDER_DELIVERIES_BY_COMMAND_ID = gql`
  query orderDeliveries(
  $commandId: UUID!,
  $first: Int,
  $after: Cursor,
  $before: Cursor,
  $last: Int,  
  ) {
    orderDeliveries(
    first: $first,
    after: $after,
    before: $before,
    last: $last,
    filter: { commandId: { equalTo: $commandId } }) {
      edges {
        node {
          command {
            clientName
          }
          commandId
          commentDriver
          commentPrivate
          commentPublic
          deliveryDate
          deliveryTimeStart
          deliveryTimeEnd
          deliverySite {
            address
            city
            code
            id
            isSite
          }
          deliverySiteAddress
          deliverySiteBdn {
            address
            city
            code
            id
            isSite
          }
          deliverySiteBdnId
          deliverySiteCity
          deliverySiteId
          id
          licensePlate
          orderDeliveryMaterials {
            nodes {
              material {
                id
                internalId
                description
                measureUnitByBaseMeasureUnitCode {
                  abbr
                }
                productCategoryByIdProductCategory {
                  family
                }
              }
              commandMaterialId
              id
              materialId
              quantity
            }
          }
          orderDeliveryNumber
          phoneNumber
          scanCmr
          scanProviderDeliveryNote
          scanSignature
          startingSite {
            address
            city
            code
            id
            isSite
          }
          startingSiteAddress
          startingSiteBdn {
            address
            city
            code
            id
            isSite
          }
          startingSiteBdnId
          startingSiteCity
          startingSiteId
          status
          unloadingSite {
            address
            city
            code
            id
            isSite
          }
          unloadingSiteAddress
          unloadingSiteBdn {
            address
            city
            code
            id
            isSite
          }
          unloadingSiteBdnId
          unloadingSiteCity
          unloadingSiteId
          user {
            firstname
            lastname
          }
          userId
          isPlanificationSent
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
  }
`

const ORDER_DELIVERIES = gql`
  query orderDeliveries(
    $startDate: Date,
    $endDate: Date,
    $search: String,
    $searchNoSpaces: String
  ) {
    orderDeliveries(filter: {
        deliveryDate: { greaterThanOrEqualTo: $startDate, lessThan: $endDate }
        or: [
          { phoneNumber: { includesInsensitive: $search } }
          { phoneNumber: { includesInsensitive: $searchNoSpaces } }
          { command: { clientName: { includesInsensitive: $search } } }
          { command: { commandNumber: { includesInsensitive: $search } } }
          { deliverySiteAddress: { includesInsensitive: $search } }
          { deliverySite: { city: { includesInsensitive: $search } } }
          { deliverySiteBdn: { city: { includesInsensitive: $search } } }
          { deliverySiteCity: { includesInsensitive: $search } }
          { startingSiteAddress: { includesInsensitive: $search } }
          { startingSite: { city: { includesInsensitive: $search } } }
          { startingSiteBdn: { city: { includesInsensitive: $search } } }
          { startingSiteCity: { includesInsensitive: $search } }
          { unloadingSiteAddress: { includesInsensitive: $search } }
          { unloadingSite: { city: { includesInsensitive: $search } } }
          { unloadingSiteBdn: { city: { includesInsensitive: $search } } }
          { unloadingSiteCity: { includesInsensitive: $search } }
          { orderDeliveryMaterials: { some: { material: { or: [
            { description: { includesInsensitive: $search } }
            { productCategoryByIdProductCategory: { familyText: { includesInsensitive: $search } } }
          ] } } } }
        ]
      }) {
      edges {
        node {
          command {
            clientName
            commandNumber
            contactName
            contactPhone
            comment
            status
          }
          commandId
          commentDriver
          commentPrivate
          commentPublic
          deliveryDate
          deliveryTimeStart
          deliveryTimeEnd
          deliverySite {
            address
            city
            code
            id
            isSite
          }
          deliverySiteAddress
          deliverySiteBdn {
            address
            city
            code
            id
            isSite
          }
          deliverySiteBdnId
          deliverySiteCity
          deliverySiteId
          id
          licensePlate
          orderDeliveryMaterials {
            nodes {
              material {
                id
                internalId
                description
                measureUnitByBaseMeasureUnitCode {
                  abbr
                }
                productCategoryByIdProductCategory {
                  family
                }
              }
              commandMaterialId
              id
              materialId
              quantity
            }
          }
          orderDeliveryNumber
          phoneNumber
          scanCmr
          scanProviderDeliveryNote
          scanSignature
          startingSite {
            address
            city
            code
            id
            isSite
          }
          startingSiteAddress
          startingSiteBdn {
            address
            city
            code
            id
            isSite
          }
          startingSiteBdnId
          startingSiteCity
          startingSiteId
          status
          unloadingSite {
            address
            city
            code
            id
            isSite
          }
          unloadingSiteAddress
          unloadingSiteBdn {
            address
            city
            code
            id
            isSite
          }
          unloadingSiteBdnId
          unloadingSiteCity
          unloadingSiteId
          user {
            firstname
            lastname
          }
          userId
          isPlanificationSent
        }
      }
    }
  }
`

const DATES_PLANIFICATION = gql`
query planifications {
  planifications {
    nodes {
      id
      sentPlanificationDate 
    }
    totalCount
  }
}
`

const CREATE_PLANIFICATION= gql`
  mutation createPlanification(
    $sentPlanificationDate: Datetime!
  ) {
    createPlanification(
      input: {
        planification: {
          sentPlanificationDate: $sentPlanificationDate
        }
      }
    ) {
      planification {
        id
      }
    }
  }
`




export default {
  CREATE_ORDER_DELIVERY,
  UPDATE_ORDER_DELIVERY,
  CREATE_ORDER_DELIVERY_MATERIAL,
  UPDATE_ORDER_DELIVERY_MATERIAL,
  DELETE_ORDER_DELIVERY_MATERIAL,
  ORDER_DELIVERIES_BY_COMMAND_ID,
  ORDER_DELIVERIES,
  DATES_PLANIFICATION,
  CREATE_PLANIFICATION
}